<!-- eslint-disable camelcase -->
<template>
  <SnackBar ref="snackbar" />
  <div :style="{ padding: '30px' }">
    <div class="flex">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <h3>{{ titulo }}</h3>
    </div>
    <br />
    <div
      v-for="n in repetir"
      :key="n"
      style="border: #e6e6e6; border-radius: 10px"
    >
      <QuestionSet
        :titulo="descricaoClassificacao[n - 1]"
        :pergunta="listaQuestoes[n - 1]"
        :quantidade="listaQuestoes[n - 1].length"
        :nome-membros="nomeMembros"
        :quantidade-linhas="nomeMembros.length"
        :fotos-membros="fotosMembros"
        :notas-dadas="notasDadas[n - 1]"
        @retorna-ao-pai="handleOptionsNotas"
      />
    </div>
    <v-btn
      dark
      class="button-config"
      v-bind="props"
      style="background-color: #004984; margin: 30px; float: right"
      @click="enviarResposta"
    >
      Enviar
    </v-btn>
  </div>
</template>

<script>
import axios from 'axios';

import QuestionSet from '@/components/QuestionSet.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    QuestionSet,
    SnackBar,
  },
  mounted() {
    var nomeMembros = [];
    var idsMembros = [];
    var imgsMembros = [];
    axios
      .get(`${API_URL}/avaliacoes/formulario/${this.$route.params.id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      })
      .then((response) => {
        this.dados = response.data;

        axios
          .get(`${API_URL}/equipes/projeto/${this.$route.params.id_proj}`, {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          })
          .then((response) => {
            response.data.tb_equipe.tb_membro.forEach((equi) => {
              if (equi.forma_atuacao != 'SCRUM_MASTER') {
                nomeMembros.push(equi.tb_usuario.nome);
                idsMembros.push(equi.tb_usuario.id_usuario);
                imgsMembros.push(equi.tb_usuario.img_url);
              }
            });
            const dados = this.dados;
            var descricaoClassificacao = [];
            var listaQuestoes = [];
            var notasDadas = [];
            var idsItemsAval = [];
            var aux = -1;
            var cont = -1;
            this.titulo = dados.titulo;
            dados.tb_questoes_formulario.forEach(function (elemento) {
              idsItemsAval.push(elemento.id_item_de_avaliacao);
              if (
                !descricaoClassificacao.includes(
                  elemento.tb_item_de_avaliacao.tb_classificacao.descricao,
                )
              ) {
                notasDadas.push([]);
                cont++;
                descricaoClassificacao.push(
                  elemento.tb_item_de_avaliacao.tb_classificacao.descricao,
                );
                aux++;
                listaQuestoes.push([]);
              }
              listaQuestoes[aux].push(elemento.tb_item_de_avaliacao.descricao);
              notasDadas[cont].push(Array(nomeMembros.length).fill(0));
            });
            this.listaQuestoes = listaQuestoes;
            this.repetir = descricaoClassificacao.length;
            this.descricaoClassificacao = descricaoClassificacao;
            this.nomeMembros = nomeMembros;
            this.idsMembros = idsMembros;
            this.notasDadas = notasDadas;
            this.idsItemsAval = idsItemsAval;
            this.fotosMembros = imgsMembros;
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
  },
  data: () => ({
    idsItemsAval: null,
    repetir: null,
    dados: null,
    titulo: null,
    listaQuestoes: null,
    classificacoes: null,
    descricaoClassificacao: null,
    nomeMembros: null,
    fotosMembros: null,
    notasDadas: null,
    idsMembros: null,
    devolver: null,
  }),
  methods: {
    handleOptionsNotas(retorno) {
      this.notasDadas[retorno[1]] = retorno[0];
      console.log(this.notasDadas);
    },
    enviarResposta() {
      this.devolver = [];
      var novasNotas = [];
      this.notasDadas.forEach((element) => {
        element.forEach((e) => {
          novasNotas.push(e);
        });
      });
      this.idsItemsAval.forEach((element, indice) => {
        this.idsMembros.forEach((ele, i) => {
          this.devolver.push({
            // eslint-disable-next-line camelcase
            id_usuario_avaliado: ele,
            // eslint-disable-next-line camelcase
            id_avaliacao: parseInt(this.$route.params.id),
            // eslint-disable-next-line camelcase
            id_item_de_avaliacao: element,
            nota: novasNotas[indice][i],
          });
        });
      });
      const data = { avaliacoes: this.devolver };
      console.log(data);
      axios
        .post(
          API_URL + `/avaliacoes/responder/${this.$route.params.id_proj}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        )
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Avaliação realizada com sucesso!',
          );
          setTimeout(() => {
            this.$router.push({
              name: 'ratingDev',
              params: { id: this.$route.params.id_proj },
            });
          }, 1000);
        })
        .catch((error) => {
          console.log(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos realizar sua avaliação!',
          );
        });
    },
  },
};
</script>

<style scoped>
.linha {
  border: 1px solid #707070;
}
.flex {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}
</style>
